import React, {useMemo} from 'react';
import {Checkbox} from 'antd';
import moment from 'moment';
import {useSelector} from 'react-redux';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {solid} from '@fortawesome/fontawesome-svg-core/import.macro';
import {Colors} from '../../../../../../styles/Colors';
import {GlobalConsts} from '../../../../../../styles/GlobalConsts';
import HStack from '../../../../../common/Layout/HStack';
import AppText from '../../../../../common/AppText';
import {t} from '../../../../../../services/i18n';
import {dbTimeFormat, getBoxTimeFormat, getPartialAttendanceDisplay} from '../../../../../../services/Helpers';
import {isEventFull} from './trackCourseSelectionHelpers';

const TrackCourseSeriesEventRow = (props) => {
    const {seriesEvent, series, onSelect, isDisabled, isChecked} = props;
    const lang = useSelector(state => state.userSettings.lang);
    const boxLocale = useMemo(() => (lang?.language === 'Hebrew' ? 'he' : 'en'), [lang]);
    const timeFormat = getBoxTimeFormat();
    const dayName = moment().weekday(seriesEvent.day_of_week).locale(boxLocale).format('dddd');
    const startTime = moment(seriesEvent.start, dbTimeFormat).format(timeFormat);
    const endTime = moment(seriesEvent.end, dbTimeFormat).format(timeFormat);
    const dayAndTime = `${dayName} ${startTime}–${endTime}`;
    const textColor = isDisabled && !isChecked ? Colors.newDesign.darkGrey : Colors.newDesign.mainText;
    const attendance = series ? getPartialAttendanceDisplay(seriesEvent.id, series) : null;
    const isFull = series ? isEventFull(series, seriesEvent.id) : false;

    return (
        <Checkbox
            checked={isChecked}
            disabled={isDisabled}
            onChange={onSelect}
            style={{marginInlineStart: 0}}
        >
            {series ? (
                <HStack space={'0.5rem'} flex={'unset'} alignItems={'center'}>
                    <AppText color={textColor}>{dayAndTime}</AppText>
                    <FontAwesomeIcon icon={solid('circle-small')} fontSize={'5px'}/>
                    <HStack space={'0.5rem'} flex={'unset'} alignItems={'center'}>
                        <FontAwesomeIcon icon={solid('user')} fontSize={GlobalConsts.iconSize.XXS}/>
                        <AppText color={textColor}>{attendance}</AppText>
                    </HStack>
                    {isFull && (
                        <>
                            <FontAwesomeIcon icon={solid('circle-small')} fontSize={'5px'}/>
                            <AppText color={Colors.newDesign.darkGrey}>{t('full-activity-day')}</AppText>
                        </>
                    )}
                </HStack>
            ) : (
                <AppText color={textColor}>{dayAndTime}</AppText>
            )}
        </Checkbox>
    );
};

export default TrackCourseSeriesEventRow;
